"use client";

import Markdown from "@/components/atoms/Markdown";
import styles from "./styles.module.scss";
import cn from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { useEffect, useMemo, useRef, useState } from "react";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import {
  OTPContext,
  OTPContextProvider,
  OTPContextWrapper,
  useOTPContext,
} from "@/components/sections/CommonModals/context";
import LandingPageConnectModalForm from "../Forms/LandingPageConnectModalForm/LandingPageConnectModalForm";
import CommonButton from "@/components/common/Analytics/CustomButton";
import { ModalTypes } from "@/types/modal";
import useOnScreen from "@/helpers/Onscreen";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { StripTextUI } from "@/data/data";

const FORM_HEADING = "Connect with our experts";

export default function LandingPageBannerCarousel({
  noteText,
  data,
  isMobile,
  showForm,
  showThankYou,
  ProgramId,
  associatedPrograms
}) {
  const [message, setMessage] = useState(null);
  
  const ref = useRef(null);
  const onScreen = useOnScreen(ref);

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        setMessage(null);
      }, 3000);
    }
  }, [message]);

  useEffect(() => {
    updateStateSession({
      formSectionName : FORM_HEADING
    })
  }, []);
  useEffect(()=>{
    const stickyElement = document.getElementById('botton-nav-container');

    if(stickyElement){
      if(onScreen){
        stickyElement.style.display = 'none'
      }else{
        stickyElement.style.display = 'flex'
      }  
    }
   
  },[onScreen])
  const Custom10PgType = associatedPrograms[0]?.attributes?.BasicDetails?.Custom10PgType || '';
  const specializationText = associatedPrograms[0]?.attributes?.BasicDetails?.specializationText || '';
  const brochure =  associatedPrograms[0]?.attributes?.BasicDetails?.Brochure?.data?.attributes?.url || '';
  const programDetails = associatedPrograms[0]?.attributes?.BasicDetails
  const stripText = isMobile ? StripTextUI.mStripTextHTML : StripTextUI.stripTextHTML;



  const [navbarComponent, setNavbarComponent] = useState(
    <CommonButton
      GADataNew={{
        event: "lead_initiate",
        cta_text: "Apply_Now",
        section_name: "strip_text_ui",
        header_title: data?.title || "NA",
        page_type: getGlobalStateValue("pageType"),
        page_url: true,
      }}
      onClickStorePayload={{
        parentSection: "strip_text_ui",
      }}
      CTATarget="_self"
      type={"button"}
      modalType={ModalTypes.ConnectModalLP}
      scroll={false}
      modalData={{ specializationText, Custom10PgType, brochure, isMobile, programDetails }}
      isHomePage
      className={styles.stripContainer}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: stripText,
        }}
      />
    </CommonButton>
  );

  useEffect(() => {

    if (window.location.pathname === "/lp-nw/scholarship-notification") {

      setNavbarComponent(
        <div
          className={styles.stripContainer}
          dangerouslySetInnerHTML={{
            __html: stripText,
          }}
        />
      );
    }
  }, []);


  return (
    <div>

      <div className="container">
        {navbarComponent}
      <div>
  
    </div>
      
  </div>
    <div className={cn("container", styles.container)}>
      <Swiper
        autoplay={{
          delay: 6000,
        }}
        modules={[Pagination, Autoplay]}
        spaceBetween={8}
        slidesPerView={1}
        pagination={{ clickable: true }}
        className={cn("Carousel__hAuto", styles.carousel, "Carousel__white_left_dot", {
          ["!w-full"]: !showForm,
        })}
      >
        {data
          ?.filter((x) => x?.enabled)
          ?.map((d, index) => (
            <SwiperSlide key={index}>
              <ImageCard
                noteText={noteText || ""}
                data={d}
                isMobile={isMobile}
                isSmallWidth={!showForm}
                associatedPrograms={associatedPrograms}
              />
            </SwiperSlide>
          ))}
      </Swiper>

      {showForm ? (
        <div ref={ref}  id="#leadform" className={cn(styles.form, styles.lpConnectModalForm )}>
          <OTPContextProvider isLambdaAPI>
            <OTPContext.Consumer>
              {() => (
                  <OTPContextWrapper isLambdaAPI>
                    <LandingPageConnectModalForm
                      ProgramId={ProgramId}
                      associatedPrograms={associatedPrograms}
                    />
                  </OTPContextWrapper>
              )}
            </OTPContext.Consumer>
          </OTPContextProvider>
          {message ? <p className={styles.success}>{"Form Submitted Successfully!"}</p> : null}
        </div>
      ) : null}
    </div>
    </div>
  );
}

function ImageCard({ data, isMobile, isSmallWidth, noteText, associatedPrograms }) {
  const imageToRender = useMemo(() => {
    const img =
      isMobile && data?.mobileSource?.data ? data?.mobileSource : data?.source;
    return strapiSingleAttribute(img);
  }, [isMobile, data?.source, data?.mobileSource]);
  const Custom10PgType = associatedPrograms[0]?.attributes?.BasicDetails?.Custom10PgType || '';
  const specializationText = associatedPrograms[0]?.attributes?.BasicDetails?.specializationText || '';
  const brochure =  associatedPrograms[0]?.attributes?.BasicDetails?.Brochure?.data?.attributes?.url || '';
  const programDetails = associatedPrograms[0]?.attributes?.BasicDetails

  return (
    <div>
    <div
      className={styles.root}
      style={{
        ...(isMobile && {
          backgroundImage: `url(${imageToRender?.url})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          minHeight: "300px",
          padding: "0 20px",
        }),
      }}
    >
      {!isMobile && <img src={imageToRender?.url} alt={data?.alt || ""} className={styles.img} />}
      <Markdown
        className={cn(styles.title, {
          [styles.smallWidth]: isSmallWidth,
        })}
      >
        {data?.title}
      </Markdown>
      {noteText && <p className={cn(styles.noteText)}>{noteText}</p>}
      
      {!isMobile && !!associatedPrograms.length && <div className={styles.downloadCTA}>
        <CommonButton
          GADataNew={{
            event : "lead_initiate",
            cta_text: "Download Brochure",
            section_name: "hero_banner",
            header_title: data?.title || "NA",
            page_type: getGlobalStateValue('pageType'),
            page_url : true
          }}
          onClickStorePayload={
            {
              parentSection : "hero_banner"
            }
          }
          CTATarget="_self"
          type={"button"}
          modalType={ModalTypes.DownloadBrochureLP}
          scroll={false}
          bg="o"
          color="b"
          icon="/_a/icons/left-arrow-blue-down.svg"
          hoverIcon="/_a/icons/arrow-down-white.svg"
          modalData={{ specializationText, Custom10PgType, brochure, isMobile, programDetails }}
          className={styles.BannerImage__CTAStyle}
        >
          Download Brochure
        </CommonButton>
      </div>}
    </div>
    </div>
  );
}
